import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'app-color-picker-v2',
    templateUrl: './color-picker-v2.component.html',
    styleUrls: ['./color-picker-v2.component.scss']
})
export class ColorPickerV2Component implements OnInit {
    customPickerVisible: boolean = false;

    @Input() colorOptions: string[]
    @Input() selectedColor: string
    @Input() defaultColorPickerBackground: string = '#000000'
    @Input() labelText: string = 'Select a theme'

    @Output() onColorChange: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('colorContainer') colorContainer!: ElementRef;

    ngOnInit() {
        this.setRollBrushBgColor(this.defaultColorPickerBackground);
    }

    togglePicker(event?: Event) {
        this.customPickerVisible = !this.customPickerVisible;
        event?.stopPropagation();
    }

    emitColorChange(color: string, type: string) {
        if (type === 'default-colors') {
            this.setRollBrushBgColor(this.defaultColorPickerBackground);
        } else if (type === 'color-picker') {
            this.setRollBrushBgColor(color);
        }
        this.selectedColor = color
        this.onColorChange.emit(this.selectedColor)
    }

    setRollBrushBgColor(color: string) {
        const outerCircle  = document.querySelector('.color-picker-circle') as HTMLElement;
        if (outerCircle) {
            outerCircle.style.backgroundColor = color;
        }
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.colorContainer?.nativeElement?.contains(event.target)) {
            this.customPickerVisible = false;
        }
    }
}
